import { MODAL_TRYIT } from '@/components/organisms/Modals/ModalConductor';
import { RootState } from '@/shared/types/state';

export const isModalOpen = (state: RootState): boolean => {
  return state.modals.length > 0;
};

export const selectIsTryItModalOpen = (state: RootState): boolean => {
  return state.modals.some((modal) => modal.kind === MODAL_TRYIT);
};
